<form [formGroup]="form" (submit)="handleSubmit($event)">
  <div class="form-wrapper reset-password">
    <mat-form-field>
      <mat-label>Old or Temp Password</mat-label>
      <input
        matInput
        [type]="hideTemp ? 'text' : 'password'"
        name="tempPassword"
        formControlName="tempPassword"
        autocomplete="temp-password"
        required
      />
      <mat-icon matSuffix (click)="hideTemp = !hideTemp">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      <mat-hint
        >If your password expired, this should be your old password. If your forgot your password, this should be the
        temporary password from your email.</mat-hint
      >
    </mat-form-field>

    <mat-form-field>
      <mat-label>New Password</mat-label>
      <input
        matInput
        [type]="hideNew ? 'text' : 'password'"
        name="newPassword"
        formControlName="password"
        (focus)="onPasswordFocused($event)"
        autocomplete="new-password"
        required
      />

      @if (password.errors?.required) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        Password is required.
      </mat-error>
      } @if (password.dirty && password.errors?.isShort) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must have at least 8 characters.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneNumber) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 number.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneUpperCase) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 upper case letter.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneLowerCase) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 lower case letter.
      </mat-error>
      } @if (password.dirty && password.errors?.notIncludeFromEmailAddress) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        Must not include any part of your email address.
      </mat-error>
      } @if (password.dirty && password.errors?.characterInvalid) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password only can include (#,$,%,&,&#64;,!) symbols.
      </mat-error>
      } @if (form.get('password').valid) {
      <fa-icon icon="check"></fa-icon>
      }
      <mat-icon matSuffix (click)="hideNew = !hideNew">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        [type]="hideConfirm ? 'text' : 'password'"
        name="confirmPassword"
        autocomplete="new-password"
        formControlName="passwordConfirm"
        pattern="{{ password.value | escapeChars }}"
        required
      />

      @if (passwordConfirm.errors?.required) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        Password is required.
      </mat-error>
      } @if (password.dirty && password.touched && passwordConfirm.errors?.pattern) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The passwords must be the same.
      </mat-error>
      } @if (form.value.password && form.get('password').valid && form.value.password === form.value.passwordConfirm) {
      <fa-icon icon="check"></fa-icon>
      }
      <mat-icon matSuffix (click)="hideConfirm = !hideConfirm">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </mat-form-field>

    <button type="submit" hidden></button>
  </div>
</form>
